import styled from '@emotion/styled';
import { getColor } from '../../common/UICommon';

export const SuggestedGuideWrapper = styled.div`
  background-color: ${getColor('LIGHT_CREAM')};
  border-radius: 12px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
export const SuggestedGuideAvatar = styled.img`
  width: 96px;
  height: 96px;
`;
export const SuggestedGuideInfoWrapper = styled.div`
  text-align: left;
`;

export const SuggestedGuideName = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${getColor('BLACK')};
  margin-bottom: 8px;
`;
export const SuggestedGuidePosition = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${getColor('GRAY_40')};
`;
